import { render, staticRenderFns } from "./ConsumerDetails.vue?vue&type=template&id=bae350ae&scoped=true&"
import script from "./ConsumerDetails.vue?vue&type=script&lang=js&"
export * from "./ConsumerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae350ae",
  null
  
)

export default component.exports